var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['sole-pagebuilder-banner',_vm.content.cssClasses],attrs:{"data-pb-style":_vm.content.pbStyle}},[_c('slide',{attrs:{"node":_vm.slide}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }